import React from 'react';
import { carBrandcodes } from 'ctm-app/client/brand-content/constants';
import { get } from 'ctm-util-functions';
import { useSelector } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';
import { SimpleFlexbox } from '../../../../../flexbox/flexbox';
import styles from './features_header.css';

export const PRODUCT_DISCLAIMER_MESSAGE = 'Available only through Compare the Market';

const getProviderCode = (stateProps) => {
    return get(stateProps, 'stateProps.product.providerMeta.code', null);
};

export const getDynamicWidth = (displayMode) => {
    return displayMode === 'column' ? '100%' : 'fit-content';
};

/**
 * Function to render the disclaimer label based on provider code.
 * @param {Object} stateProps - The stateful product object passed in.
 * @returns {React.ReactNode} - The rendered disclaimer or null if the provider doesn't match.
 */
const LayoutFeatureHeaderCellDisclaimer = (stateProps) => {
    const displayMode = useSelector(
        (state) => resultsConfigSelector(state).get('displayMode'));
    const providerName = getProviderCode(stateProps);
    const dynamicWidth = getDynamicWidth(displayMode);
    if (carBrandcodes.PROG.includes(providerName)) {
        return (
            <div>
                <SimpleFlexbox>
                    <div className={styles.disclaimer_label} style={{ width: dynamicWidth }}>
                        {PRODUCT_DISCLAIMER_MESSAGE}
                    </div>
                </SimpleFlexbox>
            </div>
        );
    }
    return null;
};

export { LayoutFeatureHeaderCellDisclaimer };
